import React from 'react'
import SideNav from './SideNav'

const Blogs = () => {
  return (
    <div>
      <>
        {/* Page Header Section */}
        <div className="page-header parallaxie">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="page-header-box">
                  <h1 className="text-anime-style-2" data-cursor="-opaque">
                    Blogs
                  </h1>
                  <div className="hero-btn wow fadeInUp" data-wow-delay="0.4s">
                    <a href="about-us" className="btn-default">About Us</a>
                    <a href="contact-us" className="btn-default btn-highlighted">Contact Us</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Blog Section */}
        <div className="page-service-single">
          <div className="container">
            <div className="row">
              
              {/* Blog Posts */}
              <div className="col-lg-8">
                <div className="service-single-content">

                  <div className="service-entry">
                    <p className="wow fadeInUp">
                      Welcome to the <b>MeHome Blog</b> — where design meets imagination. 
                      Explore stories, insights, and inspiration from our team of interior designers, 
                      architects, and creative professionals who shape spaces with purpose.
                    </p>
                    <h2 className="text-anime-style-2" data-cursor="-opaque">
                      Latest <span>Articles</span>
                    </h2>
                  </div>

                  {/* Blog Grid */}
                  <div className="page-blog mt-4">
                    <div className="container-fluid px-0">
                      <div className="row">

                        <div className="col-lg-4 col-md-6">
                          <div className="post-item wow fadeInUp">
                            <div className="post-featured-image">
                              <figure>
                                <a href="blog-single" className="image-anime" data-cursor-text="View">
                                  <img src="images/post-1.jpg" alt="How Does One Go About Buying Furniture?" />
                                </a>
                              </figure>
                            </div>
                            <div className="post-item-body">
                              <div className="post-item-content">
                                <h3><a href="blog-single">How Does One Go About Buying Furniture?</a></h3>
                              </div>
                              <div className="post-item-btn">
                                <a href="blog-single" className="post-btn">read more</a>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-4 col-md-6">
                          <div className="post-item wow fadeInUp" data-wow-delay="0.2s">
                            <div className="post-featured-image">
                              <figure>
                                <a href="blog-single" className="image-anime" data-cursor-text="View">
                                  <img src="images/post-2.jpg" alt="Innovative Décor Ideas Shaping Homes Today" />
                                </a>
                              </figure>
                            </div>
                            <div className="post-item-body">
                              <div className="post-item-content">
                                <h3><a href="blog-single">Innovative Décor Ideas Shaping Homes Today</a></h3>
                              </div>
                              <div className="post-item-btn">
                                <a href="blog-single" className="post-btn">read more</a>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-4 col-md-6">
                          <div className="post-item wow fadeInUp" data-wow-delay="0.4s">
                            <div className="post-featured-image">
                              <figure>
                                <a href="blog-single" className="image-anime" data-cursor-text="View">
                                  <img src="images/post-3.jpg" alt="Design Industry Updates You Should Know About" />
                                </a>
                              </figure>
                            </div>
                            <div className="post-item-body">
                              <div className="post-item-content">
                                <h3><a href="blog-single">Design Industry Updates You Should Know About</a></h3>
                              </div>
                              <div className="post-item-btn">
                                <a href="blog-single" className="post-btn">read more</a>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-4 col-md-6">
                          <div className="post-item wow fadeInUp" data-wow-delay="0.6s">
                            <div className="post-featured-image">
                              <figure>
                                <a href="blog-single" className="image-anime" data-cursor-text="View">
                                  <img src="images/post-4.jpg" alt="How Do You Choose the Right Lighting for Each Room?" />
                                </a>
                              </figure>
                            </div>
                            <div className="post-item-body">
                              <div className="post-item-content">
                                <h3><a href="blog-single">How Do You Choose the Right Lighting for Each Room?</a></h3>
                              </div>
                              <div className="post-item-btn">
                                <a href="blog-single" className="post-btn">read more</a>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-4 col-md-6">
                          <div className="post-item wow fadeInUp" data-wow-delay="0.8s">
                            <div className="post-featured-image">
                              <figure>
                                <a href="blog-single" className="image-anime" data-cursor-text="View">
                                  <img src="images/post-5.jpg" alt="How Can Custom Furniture Elevate Your Home's Aesthetic?" />
                                </a>
                              </figure>
                            </div>
                            <div className="post-item-body">
                              <div className="post-item-content">
                                <h3><a href="blog-single">How Can Custom Furniture Elevate Your Home's Aesthetic?</a></h3>
                              </div>
                              <div className="post-item-btn">
                                <a href="blog-single" className="post-btn">read more</a>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-4 col-md-6">
                          <div className="post-item wow fadeInUp" data-wow-delay="1s">
                            <div className="post-featured-image">
                              <figure>
                                <a href="blog-single" className="image-anime" data-cursor-text="View">
                                  <img src="images/post-6.jpg" alt="What Are Simple Ways to Refresh Your Interior on a Budget?" />
                                </a>
                              </figure>
                            </div>
                            <div className="post-item-body">
                              <div className="post-item-content">
                                <h3><a href="blog-single">What Are Simple Ways to Refresh Your Interior on a Budget?</a></h3>
                              </div>
                              <div className="post-item-btn">
                                <a href="blog-single" className="post-btn">read more</a>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-12">
                          <div className="page-pagination wow fadeInUp" data-wow-delay="1.2s">
                            <ul className="pagination">
                              <li><a href="#"><i className="fa-solid fa-angle-left"></i></a></li>
                              <li className="active"><a href="#">1</a></li>
                              <li><a href="#">2</a></li>
                              <li><a href="#">3</a></li>
                              <li><a href="#"><i className="fa-solid fa-angle-right"></i></a></li>
                            </ul>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>

                  {/* Blog Benefits Section */}
                  <div className="section-title mt-5">
                    <h2 className="text-anime-style-2" data-cursor="-opaque">
                      Why <span>Follow Our Blog</span>
                    </h2>
                  </div>
                  <ul className="wow fadeInUp" data-wow-delay="0.6s">
                    <li>Stay updated with the latest interior and construction trends.</li>
                    <li>Get insights from real MeHome projects and experiences.</li>
                    <li>Find expert advice for designing smarter, more beautiful spaces.</li>
                    <li>Be inspired by modern design ideas and timeless aesthetics.</li>
                  </ul>

                </div>
              </div>

              {/* Side Navigation */}
              <div className="col-lg-4">
                <SideNav />
              </div>

            </div>
          </div>
        </div>
      </>
    </div>
  )
}

export default Blogs
